import { BUSINESS_TYPE_LABELS } from "./businessTypes/labels";
import { compact } from "./domains";

// Sort columns and default orders for the Advertiser Overview tables (the
// rules themselves are in sortRows.js). Rows come straight from an
// advertiserOverview() result. The "Where you show up" grid's columns are in
// advertiserGrid.js.

const name = r => (r.displayName || "").toLowerCase();
const typeLabel = r => (r.businessType ? BUSINESS_TYPE_LABELS[r.businessType.type] : null);

// Rank order; advertisers with no rank (never seen) go last.
export function byRank(a, b) {
  if (a.rank == null && b.rank == null) return name(a).localeCompare(name(b));
  if (a.rank == null) return 1;
  if (b.rank == null) return -1;
  return a.rank - b.rank;
}

// "Where you rank" (window rows) and its expanded full ranking (picker rows).
export const RANK_COLUMNS = {
  rank: { value: r => r.rank, first: "asc" },
  advertiser: { value: name, first: "asc" },
  type: { value: typeLabel, first: "asc" },
  visibility: { value: r => r.visibility?.score ?? null, first: "desc" },
  searches: { value: r => r.visibility?.searches ?? null, first: "desc" },
};

// "Who you're up against": default = most shared searches, ties by visibility.
export const RIVAL_COLUMNS = {
  advertiser: { value: name, first: "asc" },
  type: { value: typeLabel, first: "asc" },
  shared: { value: r => r.sharedSearches, first: "desc" },
  visibility: { value: r => r.visibility.score, first: "desc" },
};
export function rivalDefaultCompare(a, b) {
  return b.sharedSearches - a.sharedSearches || b.visibility.score - a.visibility.score || name(a).localeCompare(name(b));
}

// Picker: default = your business first, then by rank.
export const PICKER_COLUMNS = {
  rank: { value: r => r.rank, first: "asc" },
  advertiser: { value: name, first: "asc" },
  visibility: { value: r => r.visibilityScore, first: "desc" },
};
export function pickerDefaultCompare(a, b) {
  return (b.isYourBusiness ? 1 : 0) - (a.isYourBusiness ? 1 : 0) || byRank(a, b);
}

// The picker's type-to-search: matches the name or website, ignoring case,
// spaces and punctuation.
export function searchPicker(rows, text) {
  const wanted = compact(text);
  if (!wanted) return rows;
  return rows.filter(r => compact(r.displayName).includes(wanted) || compact(r.key).includes(wanted));
}

// "Link a map pack listing" (rows from listingsForLinking): default = name A-Z.
export const LISTING_COLUMNS = {
  name: { value: r => r.name.toLowerCase(), first: "asc" },
  postcodes: { value: r => r.postcodes, first: "desc" },
  linkedTo: { value: r => r.linkedTo || null, first: "asc" },
};
export function listingDefaultCompare(a, b) {
  return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
}
